export const USER_DATA                  = "USER_DATA";
export const INIT_LOGOUT                = "INIT_LOGOUT";

export const PAGE_LOADING               = "PAGE_LOADING";

export const JOB_REFERENCE_DATA         = "JOB_REFERENCE_DATA";
export const ADD_JOB_REFERENCE          = "ADD_JOB_REFERENCE";
export const REMOVE_JOB_REFERENCE       = "REMOVE_JOB_REFERENCE";
export const JOB_DATA                   = "JOB_DATA";

export const FORM_URL                   = "FORM_URL";